import GlobalStoreHelper from './GlobalStoreHelper';

let flagOptions = false;
export default class ProductDetailPage {

    static retrieveThemeConfiguration() {
        const modalConfigs = document.querySelector('#list-of-stores-wrap');
        return modalConfigs.dataset;
    }

    /**
     * Fetch information about availability of specific product and output it accordingly
     * in product detail page,
     */
    static async outputStockInfo() {
        const stock = await GlobalStoreHelper.getCachedStock();
        const locationId = GlobalStoreHelper.getItem('locationId')
        const locations = GlobalStoreHelper.getItem('locations')
        const containerForStock = document.querySelector('#AddToCartForm .speed-pickup');
        const { show, minAmount, collectionsExcluded } = window.freeShipping;
        const price = Number(document.querySelector('.free-shipping-message').dataset.productPrice || 0) / 100;
        const collections = JSON.parse(document.querySelector('.free-shipping-message').dataset.productCollections);
        const warehouseTag = JSON.parse(document.querySelector('.free-shipping-message').dataset.warehouseTag);
        const peninsulaStockTag = JSON.parse(document.querySelector('.free-shipping-message').dataset.peninsulaStockTag);
        const isReleaseUnknow = !!window.product_tags?.match(/.*presale-noprevision.*/)?.length
        const noEnvioTag = !!window.product_tags?.match(/(?:^|,)\s*no_envio\s*(?:,|$)/);

        // In case store delivery is disabled, abort
        if (!containerForStock) return;

        const storeWrap = containerForStock.querySelector('.store');
        const storeBubble = containerForStock.querySelector('.store .fa-circle');
        const storeLabel = containerForStock.querySelector('.store span');
        const additionalLabel = containerForStock.querySelector('.additional-message');
        const onlineWrap = containerForStock.querySelector('.online');
        const onlineWrapDisclaimer = containerForStock.querySelector('.disclaimer');
        const onlineBubble = containerForStock.querySelector('.online .fa-circle');
        const onlineLabel = containerForStock.querySelector('.online span');
        const storeName = containerForStock.querySelector('#store-name');
        const qtySelector = document.querySelector('.quantity_wanted_p select.quantity-selector');

        qtySelector.addEventListener('change', (_e) => this.outputStockInfo() ,{ once: true });
        let totalSelectStock = 0;
        let optionsSelectStock;

        const stockAndRequestedQty = stock.map((st) => {
          totalSelectStock += st.quantity;
          st.locationId === locationId && (st.requestedQty = Number(qtySelector.options[qtySelector.selectedIndex].value));
          return st;
        });

        const productUnitsLimitNumber = Number(qtySelector.dataset.productUnitsLimitNumber);
        const productQuantityCart = Number(qtySelector.dataset.productQuantityCart) ;
        const productQuantityCartMax = totalSelectStock <= productUnitsLimitNumber ? totalSelectStock - productQuantityCart : productUnitsLimitNumber - productQuantityCart;
        const addToCart = document.querySelectorAll('#AddToCart');
        const showBackInStock = document.querySelector('#instock');

        if (productQuantityCartMax <= 0 && totalSelectStock > 0) {
          const hideOptions = document.querySelector('.product-availability');
          const hideQty = document.querySelector('.quantity_wanted_p');
          hideOptions.remove();
          hideQty.remove();

          const dynamicOptions = document.querySelectorAll('[id^="dynamic_option_"]');
          dynamicOptions.length && dynamicOptions.forEach((node) => node.remove());

          const alertUnits = document.querySelector('.alert-units-limit');
          const messageAlert = alertUnits.dataset.messageAlert;
          alertUnits.innerHTML = messageAlert;
          alertUnits.style.display = 'block';

          const buttons = document.querySelectorAll('#AddToCartForm #AddToCart');

          buttons.length && buttons.forEach((node) => node.remove());
          addToCart.length && addToCart.forEach(button => button.classList.add('disabled'));
        } else if (totalSelectStock <= 0) {
          const divQty = document.querySelector('.quantity_wanted_p');
          divQty.remove();
          showBackInStock.style.display = 'block';
          addToCart.length && addToCart.forEach(button => button.classList.add('disabled'));
        }

        if(!flagOptions) {
          for (let index = 2; index <= totalSelectStock; index++) {
            if (totalSelectStock >= index && productQuantityCartMax >= index && productUnitsLimitNumber >= index) {
              optionsSelectStock = document.createElement('option');
              optionsSelectStock.value = index;
              optionsSelectStock.innerHTML = index;
              qtySelector.appendChild(optionsSelectStock);
            } else break;
          }

          flagOptions = true;
        }

        const labelInfo = await GlobalStoreHelper.createPromiseObject(stockAndRequestedQty, {
          locationId,
          smallDate: true,
          newLine: false,
          addStoreSelector: false,
          warehouseTag,
          peninsulaStockTag,
          isReleaseUnknow,
          noEnvioTag
        });

        if(!labelInfo) return
        const currLocationStock = stock.filter(location => location.locationId === locationId);
        let onlineLocation = stock.filter(location => location.onlineStore);

        // If online stock is not sufficient, replace bubble with location with store delivery
        if (onlineLocation[0].quantity < 1) {
          const storeDelivery = stock.filter((location) => location.isPhysicalStore && location.quantity > 0);
          if (storeDelivery.length) {
            onlineLocation = storeDelivery;
          }
        }
        containerForStock.querySelector('.store-location').classList.add('show');
        onlineBubble.classList.remove('green', 'yellow', 'red', 'grey');
        onlineBubble.classList.add(labelInfo.online.color);
        onlineLabel.innerHTML = labelInfo.online.message;

        const flagExcludedCollection = !!collections.find((coll) => collectionsExcluded.includes(coll));

        if(isReleaseUnknow) {
          additionalLabel.classList.remove('hide');
          additionalLabel.innerHTML = window.promises.release_unknown;
        }

        if(labelInfo.online.color === "green" && show && price > minAmount && !flagExcludedCollection) {
          document.querySelector('.free-shipping-message').classList.remove('hide');
        }

        if (!labelInfo.online.message) {
            onlineWrap.classList.add('d-none');
            onlineWrapDisclaimer.classList.add('d-none');
        }

        if (labelInfo.store.message) {
          storeWrap.classList.remove('d-none');
          containerForStock.querySelector('.store-location').classList.remove('d-none');
        }

        storeBubble.classList.remove('green', 'yellow', 'red', 'grey');
        storeBubble.classList.add(labelInfo.store.color);
        storeLabel.innerHTML = labelInfo.store.pdpMessage || labelInfo.store.message;
        storeName.innerHTML = locations ? locations[locationId]?.name || '' : '';

        // Remove Explicit Store selector when pre-sale
        if (labelInfo.store.labelOnly) {
          containerForStock.querySelector('.store-location').classList.add('d-none');
          containerForStock.querySelector('.store .shipping-option-price').classList.add('d-none');
        }
        document.querySelector('.speed-pickup .when-loaded').classList.remove('hide');

        const configs = this.retrieveThemeConfiguration();
        if (configs.hidePhysicalStorePromises && configs.hidePhysicalStorePromises === 'true') {
            document.querySelector('.speed-pickup .store').classList.add('d-none');
            document.querySelector('.speed-pickup .disclaimer').classList.add('no-margin');
            document.querySelector('.speed-pickup .store-location').classList.add('hide');
            document.querySelector('.speed-pickup .store-location').classList.remove('show');
        }

        // Modify add to cart button depending on stock info
        const button = document.querySelector('#AddToCartForm #AddToCart');
        const textEl = document.getElementById('AddToCartText');

        if (currLocationStock[0]?.quantity < 1 && onlineLocation[0].quantity < 1) {
          button.classList.add('disabled');
          textEl.innerHTML = textEl.dataset.disabledText || window.product_text.sold_out;
          button.disabled = true;
        } else {
          textEl.innerHTML = textEl.dataset.enabledText || window.product_text.add_to_cart;
          button.classList.remove('disabled');
          button.disabled = false;
        }

        // To fix the interference caused by 3rd party apps on button, lets trigger click on form
        document.getElementById('AddToCartForm').click();
    }
}
